export default __webpack_public_path__ + "static/media/INFOCOIN-Blank-A4-2022-Cyprus.5afcff47.png";